import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Skeleton,
  Box,
} from '@mui/material';

const TableSkeleton = ({
  columns = 5,
  rows = 5,
  showHeader = true,
  dense = false,
}) => {
  const cellHeight = dense ? 40 : 53;

  return (
    <TableContainer>
      <Table size={dense ? 'small' : 'medium'}>
        {showHeader && (
          <TableHead>
            <TableRow>
              {Array.from({ length: columns }).map((_, index) => (
                <TableCell
                  key={`header-${index}`}
                  sx={{
                    fontWeight: 600,
                    borderBottom: '2px solid',
                    borderColor: 'grey.200',
                  }}
                >
                  <Skeleton
                    variant="text"
                    width={index === 0 ? 120 : 80}
                    height={24}
                  />
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
        )}
        <TableBody>
          {Array.from({ length: rows }).map((_, rowIndex) => (
            <TableRow
              key={`row-${rowIndex}`}
              sx={{
                backgroundColor: rowIndex % 2 === 0 ? 'transparent' : 'grey.50',
              }}
            >
              {Array.from({ length: columns }).map((_, colIndex) => (
                <TableCell
                  key={`cell-${rowIndex}-${colIndex}`}
                  sx={{
                    height: cellHeight,
                    borderBottom: '1px solid',
                    borderColor: 'grey.100',
                  }}
                >
                  {colIndex === 0 ? (
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
                      <Skeleton variant="rounded" width={36} height={36} />
                      <Box>
                        <Skeleton variant="text" width={100} height={20} />
                        <Skeleton variant="text" width={60} height={16} />
                      </Box>
                    </Box>
                  ) : colIndex === columns - 1 ? (
                    <Box sx={{ display: 'flex', gap: 0.5, justifyContent: 'center' }}>
                      <Skeleton variant="circular" width={28} height={28} />
                      <Skeleton variant="circular" width={28} height={28} />
                    </Box>
                  ) : (
                    <Skeleton
                      variant="text"
                      width={colIndex === 1 ? 150 : 80}
                      height={20}
                    />
                  )}
                </TableCell>
              ))}
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default TableSkeleton;
